module.exports = __webpack_public_path__ + "static/img/WEEZIE_logo_PNI.6cfa2d8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logos/WEEZIE_logo_PNI.png
// module id = mps1
// module chunks = 0